(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["crops-recommendations"] && !Shopify.designMode) return;
  try {
    
  // Arrow controls + auto-hide when content does not overflow
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.crop-recs .carousel').forEach(carousel => {
      const track = carousel.querySelector('.carousel__track');
      const left = carousel.querySelector('.carousel__arrow.left');
      const right = carousel.querySelector('.carousel__arrow.right');

      const getStep = () => {
        const card = track.firstElementChild;
        const gap = 16;
        return card ? (card.getBoundingClientRect().width + gap) : 240;
      };

      function updateArrows() {
        const scrollable = track.scrollWidth > track.clientWidth + 1;
        carousel.classList.toggle('is-scrollable', scrollable);
      }

      left?.addEventListener('click', () => track.scrollBy({ left: -getStep(), behavior: 'smooth' }));
      right?.addEventListener('click', () => track.scrollBy({ left: getStep(),  behavior: 'smooth'  }));

      updateArrows();
      window.addEventListener('resize', updateArrows);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
